// This file was generated by "make codegen/iam". DO NOT EDIT.

import { roleOrgMember, type RoleOrgMember } from "./OrgMember";
import { roleSpaceMember, type RoleSpaceMember } from "./SpaceMember";
import { roleOwner, type RoleOwner } from "./Owner";
import { roleEditor, type RoleEditor } from "./Editor";
import { roleViewer, type RoleViewer } from "./Viewer";
import { roleAgent, type RoleAgent } from "./Agent";
import { roleGatewayAgent, type RoleGatewayAgent } from "./GatewayAgent";
import { roleBillingManager, type RoleBillingManager } from "./BillingManager";
import { roleScanJobRunner, type RoleScanJobRunner } from "./ScanJobRunner";
import { roleExportRunner, type RoleExportRunner } from "./ExportRunner";
import { roleVexImporter, type RoleVexImporter } from "./VexImporter";
import {
  roleDeploymentManager,
  type RoleDeploymentManager,
} from "./DeploymentManager";
import { rolePlatformAdmin, type RolePlatformAdmin } from "./PlatformAdmin";
import {
  roleExceptionReviewer,
  type RoleExceptionReviewer,
} from "./ExceptionReviewer";
import {
  roleScimIdentityManager,
  type RoleScimIdentityManager,
} from "./ScimIdentityManager";
import {
  roleQueryPackEditor,
  type RoleQueryPackEditor,
} from "./QueryPackEditor";
import {
  roleQueryPackManager,
  type RoleQueryPackManager,
} from "./QueryPackManager";
import { rolePolicyEditor, type RolePolicyEditor } from "./PolicyEditor";
import { rolePolicyManager, type RolePolicyManager } from "./PolicyManager";
import {
  roleExceptionsRequester,
  type RoleExceptionsRequester,
} from "./ExceptionsRequester";
import { roleTicketCreator, type RoleTicketCreator } from "./TicketCreator";
import { roleTicketManager, type RoleTicketManager } from "./TicketManager";
import {
  roleIntegrationsManager,
  type RoleIntegrationsManager,
} from "./IntegrationsManager";
import { roleSlaManager, type RoleSlaManager } from "./SlaManager";
import {
  rolePolicyAnalyticsDashboardViewer,
  type RolePolicyAnalyticsDashboardViewer,
} from "./PolicyAnalyticsDashboardViewer";
import { roleBiViewer, type RoleBiViewer } from "./BiViewer";
import {
  roleApiTokenCreator,
  type RoleApiTokenCreator,
} from "./ApiTokenCreator";
import {
  roleApiTokenManager,
  type RoleApiTokenManager,
} from "./ApiTokenManager";
import {
  roleServiceAccountCreator,
  type RoleServiceAccountCreator,
} from "./ServiceAccountCreator";
import {
  roleServiceAccountManager,
  type RoleServiceAccountManager,
} from "./ServiceAccountManager";
import {
  roleRegistrationTokenCreator,
  type RoleRegistrationTokenCreator,
} from "./RegistrationTokenCreator";
import {
  roleRegistrationTokenManager,
  type RoleRegistrationTokenManager,
} from "./RegistrationTokenManager";

// All roles
export type Role =
  | RoleOrgMember
  | RoleSpaceMember
  | RoleOwner
  | RoleEditor
  | RoleViewer
  | RoleAgent
  | RoleGatewayAgent
  | RoleBillingManager
  | RoleScanJobRunner
  | RoleExportRunner
  | RoleVexImporter
  | RoleDeploymentManager
  | RolePlatformAdmin
  | RoleExceptionReviewer
  | RoleScimIdentityManager
  | RoleQueryPackEditor
  | RoleQueryPackManager
  | RolePolicyEditor
  | RolePolicyManager
  | RoleExceptionsRequester
  | RoleTicketCreator
  | RoleTicketManager
  | RoleIntegrationsManager
  | RoleSlaManager
  | RolePolicyAnalyticsDashboardViewer
  | RoleBiViewer
  | RoleApiTokenCreator
  | RoleApiTokenManager
  | RoleServiceAccountCreator
  | RoleServiceAccountManager
  | RoleRegistrationTokenCreator
  | RoleRegistrationTokenManager;

export type RolesByMrn = {
  [mrn in Role["mrn"]]: Extract<Role, { mrn: mrn }>;
};

export const rolesByMrn: RolesByMrn = {
  [roleOrgMember.mrn]: roleOrgMember,
  [roleSpaceMember.mrn]: roleSpaceMember,
  [roleOwner.mrn]: roleOwner,
  [roleEditor.mrn]: roleEditor,
  [roleViewer.mrn]: roleViewer,
  [roleAgent.mrn]: roleAgent,
  [roleGatewayAgent.mrn]: roleGatewayAgent,
  [roleBillingManager.mrn]: roleBillingManager,
  [roleScanJobRunner.mrn]: roleScanJobRunner,
  [roleExportRunner.mrn]: roleExportRunner,
  [roleVexImporter.mrn]: roleVexImporter,
  [roleDeploymentManager.mrn]: roleDeploymentManager,
  [rolePlatformAdmin.mrn]: rolePlatformAdmin,
  [roleExceptionReviewer.mrn]: roleExceptionReviewer,
  [roleScimIdentityManager.mrn]: roleScimIdentityManager,
  [roleQueryPackEditor.mrn]: roleQueryPackEditor,
  [roleQueryPackManager.mrn]: roleQueryPackManager,
  [rolePolicyEditor.mrn]: rolePolicyEditor,
  [rolePolicyManager.mrn]: rolePolicyManager,
  [roleExceptionsRequester.mrn]: roleExceptionsRequester,
  [roleTicketCreator.mrn]: roleTicketCreator,
  [roleTicketManager.mrn]: roleTicketManager,
  [roleIntegrationsManager.mrn]: roleIntegrationsManager,
  [roleSlaManager.mrn]: roleSlaManager,
  [rolePolicyAnalyticsDashboardViewer.mrn]: rolePolicyAnalyticsDashboardViewer,
  [roleBiViewer.mrn]: roleBiViewer,
  [roleApiTokenCreator.mrn]: roleApiTokenCreator,
  [roleApiTokenManager.mrn]: roleApiTokenManager,
  [roleServiceAccountCreator.mrn]: roleServiceAccountCreator,
  [roleServiceAccountManager.mrn]: roleServiceAccountManager,
  [roleRegistrationTokenCreator.mrn]: roleRegistrationTokenCreator,
  [roleRegistrationTokenManager.mrn]: roleRegistrationTokenManager,
};

export const roles = Object.values(rolesByMrn).sort(sortByAllowedActions);

// Available roles for users being assigned to orgs and spaces
export type MemberRole = RoleOwner | RoleEditor | RoleViewer;

export type MemberRolesByMrn = {
  [mrn in MemberRole["mrn"]]: Extract<MemberRole, { mrn: mrn }>;
};

export const memberRolesByMrn: MemberRolesByMrn = {
  [roleOwner.mrn]: roleOwner,
  [roleEditor.mrn]: roleEditor,
  [roleViewer.mrn]: roleViewer,
};

export const memberRoles =
  Object.values(memberRolesByMrn).sort(sortByAllowedActions);

// Available roles for service accounts being assigned to orgs and spaces
export type ServiceAccountRole =
  | RoleOwner
  | RoleEditor
  | RoleViewer
  | RoleAgent;

export type ServiceAccountRolesByMrn = {
  [mrn in ServiceAccountRole["mrn"]]: Extract<ServiceAccountRole, { mrn: mrn }>;
};

export const serviceAccountRolesByMrn: ServiceAccountRolesByMrn = {
  [roleOwner.mrn]: roleOwner,
  [roleEditor.mrn]: roleEditor,
  [roleViewer.mrn]: roleViewer,
  [roleAgent.mrn]: roleAgent,
};

export const serviceAccountRoles = Object.values(serviceAccountRolesByMrn).sort(
  sortByAllowedActions,
);

// Helpers
export function isRoleMrn(value: any): value is Role["mrn"] {
  return Object.keys(rolesByMrn).includes(value);
}

export function roleFromMrn(mrn: Role["mrn"]): Role {
  return rolesByMrn[mrn];
}

export function roleFromMrnString(mrn: string): Role | undefined {
  return isRoleMrn(mrn) ? roleFromMrn(mrn) : undefined;
}

export function sortByAllowedActions(a: Role, b: Role): number {
  return a.allowedActions.length - b.allowedActions.length;
}
